import { useEffect, useState } from "react";
import { Button, Input, Modal, Popconfirm, Space, Table, message } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import PermissionApi from "../../api/PermissionApi";
import StringUtils from "../../util/StringUtils";
import { ColumnType } from "antd/es/table";
import { FilterItem, FilterItemLabel, RoleManagementWrapper, TableWrapper, ToolBarLeftWrapper, ToolBarRightWrapper, ToolBarWrapper } from "./RoleManagement.styled";
import CreateRoleWizard from "./components/create-role-wizard/CreateRoleWizard";

interface RoleManagementProps {

}

const RoleManagement: React.FC<RoleManagementProps> = (props) => {
    // api
    let permissionApi = new PermissionApi();
    let [messageApi, contextHolder] = message.useMessage();

    // state
    let [roles, setRoles] = useState([]);
    let [filterRoles, setFilterRoles] = useState([]);
    let [editingRole, setEditingRole] = useState(null);
    let [openRoleModal, setOpenRoleModal] = useState(false);

    let [loading, setLoading] = useState(true);
    let [search, setSearch] = useState("");
    let [tableParams, setTableParams] = useState<any>({
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
            showSizeChanger: true,
            pageSizeOptions: [10, 20, 50],
        },
    });

    // events

    let viewRoleDetails = (role: any)=> {
        setEditingRole(role);
        setOpenRoleModal(true);
    };

    let onSearchChange = (e)=> {
        let search = e.target.value;
        setSearch(search);
        
        let filterRoles = [].concat(roles);
        if (!StringUtils.isEmpty(search)) {
            filterRoles = roles.filter((role)=> {
                if (role.name.indexOf(search) >= 0) {
                    return true;
                }
                if (role.email.indexOf(search) >= 0) {
                    return true;
                }
                return false;
            });
        }
        setFilterRoles(filterRoles);
    }

    let onTableChange = (pagination)=> {
        tableParams.pagination = pagination;
        setTableParams({pagination: pagination});
        loadRoles();
    };

    let onCreateRoleClick = ()=> {
        setEditingRole(null);
        setOpenRoleModal(true);
    };

    let onDeleteRole = async (role: any)=> {
        await permissionApi.deleteRole(role.id);
        messageApi.open({
            type: 'success',
            content: '删除角色成功',
          });
        loadRoles();
    }

    // load device views
    let loadRoles = async ()=> {
        // loading animation
        setLoading(true);
        let roles = (await permissionApi.getRoles()).data.data;
        setRoles(roles);
        setFilterRoles([].concat(roles));
        setLoading(false);
    };

    // effect
    useEffect(()=> {
        loadRoles();
    }, []);

    // column definition
    let columns: ColumnType<any>[] = [
        {
            title: '名称',
            dataIndex: 'role.name',
            key: 'role.name',
            align: 'center',
            render: (text, record, index)=> {
                return <a onClick={()=> viewRoleDetails(record)}>{record.name}</a>
            }
        },
        {
            title: '备注',
            dataIndex: 'user.remarks',
            key: 'user.remarks',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{StringUtils.emptyToSlash(record.remarks)}</span>
            }
        },
        {
            title: '操作',
            key: 'action',
            align: 'center',
            render: (text, record, index)=> {
                return <Space size="middle">
                    <a onClick={()=> viewRoleDetails(record)}>查看详情</a>
                    { record.name != 'admin' && <Popconfirm
                            title="删除角色"
                            description={ <div style={{paddingTop: "10px", paddingBottom: '10px'}}>确认要删除此角色么?</div> }
                            onConfirm={()=> onDeleteRole(record)}
                            okText="确定"
                            cancelText="取消"
                        > 
                        <a>删除角色</a>
                    </Popconfirm> }
                </Space>
            }
        }
    ];

    // render
    return <RoleManagementWrapper>
        {contextHolder}
        <ToolBarWrapper>
            <ToolBarLeftWrapper>
                <Space size="middle">
                    <Button type="primary" icon={<PlusOutlined />} onClick={onCreateRoleClick}>添加角色</Button>
                </Space>
            </ToolBarLeftWrapper>

            <ToolBarRightWrapper>
                <FilterItem>
                    <Input 
                        placeholder="请输入关键字" 
                        suffix={<SearchOutlined />} 
                        size="middle" 
                        value={search} 
                        onChange={(e)=> onSearchChange} 
                    />
                </FilterItem>
            </ToolBarRightWrapper>

            <Modal open={openRoleModal} 
                onClose={()=> setOpenRoleModal(false)} 
                destroyOnClose={true} 
                footer={null} 
                closable={false}
                width={1000}
                height={600}
                >
                <CreateRoleWizard onClose={()=> setOpenRoleModal(false)} onComplete={()=> loadRoles()} editingRoleId={editingRole?.id} />
            </Modal>
        </ToolBarWrapper>
        <TableWrapper>
            <Table
                rowKey={(record) => record.id}
                columns={columns}
                dataSource={roles}
                pagination={tableParams.pagination}
                loading={loading}
            />
        </TableWrapper>
    </RoleManagementWrapper>
};

export default RoleManagement;
